import { promotionsV2Actions } from '../../../store/slices/promotionsV2/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface PrizeDropWinMessage extends GameCommunicationMessageType {
  amount: string;
  beforeInit: boolean;
  bet: string;
  delay: number;
  id: string;
  mul: string;
  pdid: string;
  prizeType: 'C' | 'G';
  seq: number;
  table: string;
  textPrize: string;
  transId: string;
  userId: string;
  wiid: string;
}

export class CorePromotionsGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.PrizedropWin;

  public process(message: PrizeDropWinMessage): void {
    this.store.dispatch(promotionsV2Actions.setPrizeDropSocketResponse(message as any));
  }
}
